export default __webpack_public_path__ + "static/4-8a412bbf95dd87d9f3f0c75c127db069.png";